import Footer from './Footer'
import './Footer.css'
import './background.css'

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js